import styled from 'styled-components';

export const FormInputError = styled.div`
  margin-top: 0.25em;
  font-size: 13px;
  color: #cc0033;

  height: 18px;
`;
